import loadable from '@loadable/component';
import type { Locale } from '../locales';

/* istanbul ignore file */

export function getPolyfills(locale: Locale) {
  switch (locale) {
    case 'ar-SA':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/ar" */ './ar-SA'));
    case 'de-DE':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/de" */ './de'));
    case 'es-ES':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/es" */ './es'));
    case 'fr-FR':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/fr" */ './fr'));
    case 'he-IL':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/he" */ './he'));
    case 'hi-IN':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/hi" */ './hi'));
    case 'it-IT':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/it" */ './it'));
    case 'ja-JP':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/ja" */ './ja'));
    case 'ko-KR':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/ko" */ './ko'));
    case 'nb-NO':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/nb" */ './nb'));
    case 'nl-NL':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/nl" */ './nl'));
    case 'pt-BR':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/pt-BR" */ './pt-BR'));
    case 'ro-RO':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/ro" */ './ro'));
    case 'ru-RU':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/ru" */ './ru'));
    case 'sv-SE':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/sv" */ './sv'));
    case 'zh-CN':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/zh-CN" */ './zh-CN'));
    case 'zh-TW':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/zh-TW" */ './zh-TW'));

    case 'xx-HA':
    case 'en-XA':
    case 'en':
      return loadable.lib(() => import(/* webpackChunkName: "polyfills/en" */ './en'));
  }
}
